import { forwardRef } from "react"

import { TransferPrintViewTable } from "./TransferPrintViewTable"
import { TransferTypeChip } from "./TransferTypeChip"

import { DATE_FORMAT } from "@/constants/formats"
import type { Transfer } from "@/graphql/codegen/graphql"
import { InventoryWorkOrderPrintLayout } from "@/screens/Inventory/components"
import { InventoryHoldArea } from "@/screens/Inventory/constants"
import { formatDate } from "@/utils/date"
import { formatWarehouseLabel } from "@/utils/warehouse"

const PICK_TICKET_FALLBACK_DESTINATION = { location: InventoryHoldArea.OutboundHold }

interface TransferPickTicketPrintViewProps {
  transfer: Transfer
}

export const TransferPickTicketPrintView = forwardRef<HTMLDivElement, TransferPickTicketPrintViewProps>(
  ({ transfer }, ref) => (
    <InventoryWorkOrderPrintLayout
      ref={ref}
      title={`Pick Ticket: ${transfer.referenceCode}`}
      chip={<TransferTypeChip type={transfer.transferType} />}
      workDate={formatDate(transfer.createdOn, DATE_FORMAT.US)}
      warehouseLabel={formatWarehouseLabel(transfer.sourceWarehouseArea)}
    >
      <TransferPrintViewTable transfer={transfer} fallbackDestination={PICK_TICKET_FALLBACK_DESTINATION} />
    </InventoryWorkOrderPrintLayout>
  )
)
